// @ts-nocheck
import { LICENSE_LIST_ERROR, LICENSE_LIST_LOADING, LICENSE_LIST_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const license_list = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: LICENSE_LIST_LOADING,
                data: true
            })
            Authservices.license_list(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: LICENSE_LIST_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: LICENSE_LIST_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}